// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Jty2KcDEGJws8xJ3egMA {
  font-family: var(--font-stack-full-medium);
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: var(--neutral-3);
  padding-right: 40px;
}

.ISKtce2LCSQDuot0yPIL {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ISKtce2LCSQDuot0yPIL {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.UK_Du9pXgxbFNaSEuWVw {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.i87W_8mojKTpMLfgrjOD {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.JYV70hNQ_SIRlO1QJ7Mr {
  border: 1px solid #000;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 24px;
  border-radius: 54px;
  padding: 0 10px;
  font-family: var(--font-stack-full-book);
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  color: var(--grey-color-70);
  margin: 0 10px;
  box-sizing: border-box;
}

.hhoPSawNKagdzj4SzqMf {
  padding: 5px;
  margin: -1px 10px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/components/BarChart/BarChart.module.scss"],"names":[],"mappings":"AAAA;EACE,0CAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;EACA,cAAA;EACA,sBAAA;AACF;;AACA;EACE,YAAA;EACA,qBAAA;AAEF","sourcesContent":[".headerText {\n  font-family: var(--font-stack-full-medium);\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: var(--neutral-3);\n  padding-right: 40px;\n}\n\n.newFlexDiv {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.newFlexDiv {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.flexDiv {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.subFlexDiv {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.scoreBox {\n  border: 1px solid #000;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 40px;\n  height: 24px;\n  border-radius: 54px;\n  padding: 0 10px;\n  font-family: var(--font-stack-full-book);\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1;\n  color: var(--grey-color-70);\n  margin: 0 10px;\n  box-sizing: border-box;\n}\n.iconWrapper {\n  padding: 5px;\n  margin: -1px 10px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerText": `Jty2KcDEGJws8xJ3egMA`,
	"newFlexDiv": `ISKtce2LCSQDuot0yPIL`,
	"flexDiv": `UK_Du9pXgxbFNaSEuWVw`,
	"subFlexDiv": `i87W_8mojKTpMLfgrjOD`,
	"scoreBox": `JYV70hNQ_SIRlO1QJ7Mr`,
	"iconWrapper": `hhoPSawNKagdzj4SzqMf`
};
export default ___CSS_LOADER_EXPORT___;
